function Navigation_form_access_control(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    accessControlItem: '.js-ac-item',
	    checkboxEditProfile: '.js-checkbox-edit-profile'
    };

    this.modifiers = {
	    accessControlItemEdit: 'f-navigation__access-control-item--edit'
    };

    this.triggers = {
	    afterLoaded: 'i4:afterLoaded'
    };

    this.init = function() {
	    this.$formParent = this.$element.parents(this.selectors.formParent);
        this.$checkboxEditProfile = this.$element.find(this.selectors.checkboxEditProfile);
        this.$accessControlItem = this.$element.find(this.selectors.accessControlItem);

        this.$checkboxEditProfile.on('i4:change', this.$onChangeEdit.bind(this));

		this.$formParent.on(this.triggers.afterLoaded, (function() {
			this.$updateView();
		}).bind(this));
    };

    this.$onChangeEdit = function(event) {
	    //console.log('onChangeEdit');

	    var $element = $(event.currentTarget);

	    this.checkItem($element);
    };

    this.$updateView = function() {
	    this.$accessControlItem.each((function(i, item) {
		    var $item = $(item);

		    this.checkItem($item.find(this.selectors.checkboxEditProfile));
	    }).bind(this));
    };

    this.checkItem = function($element) {
	    var $ac_item = $element.closest(this.selectors.accessControlItem);

    	if ($element.is(':checked')) {
			$ac_item.addClass(this.modifiers.accessControlItemEdit);
		} else {
			$ac_item.removeClass(this.modifiers.accessControlItemEdit);
		}
    };
}
